import { constant } from "common/constant";
import * as yup from "yup";

export const interviewSchema = yup.object({
  title: yup.string().nullable(),
  candidateName: yup.string().nullable(), 
  candidateEmail: yup.string().email(constant.invalidEmail).nullable(), 
  candidatePhone: yup.string().nullable(), 
  interviewer: yup.string().nullable(), 
  round: yup.string().nullable(), 
  interviewType: yup.string().nullable(), 
  scheduleDateAndTime: yup.date().nullable(), 
});